import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class HostOrderDetailsService {

  constructor(private http: MyHttpClient) { }
  server = `${environment.server}`;

  getTripsBulk(ids: string[], date?: string) {
    const url = `${this.server}/api/pool-manager/trips/bulk`;
    const body: { ids: string[], date?: string } = { ids };
    if (date) {
      body.date = date;
    }
    return this.http.post(url, body).pipe(catchError(this.handleError));
  }

  getPoolTripsBulk(orderIds: string[]) {
    const url = `${this.server}/api/pool-manager/pool/trips/bulk`;
    const body = { orderIds };
    return this.http.post(url, body).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }
}
